/**
 * More pretty Local Storage functions :3
 */
export default {
    get: function (key) {
        try {
            return JSON.parse(localStorage.getItem(key));
        } catch(err) {
            console.error('There was a problem parsing a local storage key:', key, err)
            return undefined
        }
    },
    set: function (key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    remove: function (key) {
        localStorage.removeItem(key);
    },
    flush: function () {
        localStorage.clear();
    }
};
